var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D0B0B",
    d: "M3.5 2.855h9.1v6.423H3.5V2.855Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD3A3A",
    d: "M11.971 12.133c1.35 0 2.029-.678 2.029-2.043V2.043C14 .679 13.322 0 11.971 0H6.357C5.601 0 4.948.198 4.42.771L.614 4.805C.194 5.246 0 5.642 0 6.057c0 .409.187.81.614 1.252l3.811 4.014c.537.566 1.183.804 1.939.804l5.607.006Zm-1.505-3.15a.566.566 0 0 1-.4-.165L8.178 6.881 6.286 8.818a.566.566 0 0 1-.4.165.588.588 0 0 1-.582-.586c0-.152.065-.297.175-.416l1.88-1.924-1.88-1.918a.595.595 0 0 1 .407-1.015c.148 0 .29.06.407.178l1.886 1.925 1.88-1.925a.564.564 0 0 1 .407-.178.59.59 0 0 1 .582.6.586.586 0 0 1-.175.415l-1.88 1.918 1.88 1.924a.585.585 0 0 1-.407 1.002Z"
  })));
};
export default SvgClose;